<!--Stats and Options-->
<!--Stats and Option Selector-->
<div class="lock-to-top" style="background-color: #ffffff; margin-bottom: 25px; margin-top: 0">
	<div class="date-body">
		<div class="selector-body">
			<div class="selector-item" style="display: flex">
				<div>
					<label>Start Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						showIcon="true"
						showButtonBar="true"
						[(ngModel)]="StartDate"
						(ngModelChange)="onStartDateChange($event)"
						name="StartDate"
					></p-calendar>
				</div>
			</div>

			<div class="selector-item" style="display: flex">
				<div>
					<label>End Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						showIcon="true"
						showButtonBar="true"
						[(ngModel)]="EndDate"
						(ngModelChange)="onEndDateChange($event)"
						name="EndDate"
					></p-calendar>
				</div>
			</div>
		</div>
	</div>

	<div class="error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
		<div class="error-div">
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>

	<div class="total-body">
		<div *ngIf="LoadingData == false" class="StatsGrid" style="margin-left: 20px; margin-right: 20px; padding-bottom: 5px">
			<div>
				<label>Present:</label>
				<label class="statcount">{{ PresentCount }}</label>
				<label class="statpct">({{ PresentPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Absences:</label>
				<label class="statcount">{{ AbsenceCount }}</label>
				<label class="statpct">({{ AbsenceCountPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Tardies:</label>
				<label class="statcount">{{ TardyCount }}</label>
				<label class="statpct">({{ TardyCountPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Class Cuts:</label>
				<label class="statcount">{{ ClassCutCount }}</label>
				<label class="statpct">({{ ClassCutCountPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Excused Absences:</label>
				<label class="statcount">{{ ExcusedAbsenceCount }}</label>
				<label class="statpct">({{ ExcusedAbsenceCountPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Excused Tardies:</label>
				<label class="statcount">{{ ExcusedTardyCount }}</label>
				<label class="statpct">({{ ExcusedTardyCountPCT | number : "1.0-2" }}%)</label>
			</div>

			<div>
				<label>Total Records:</label>
				<label class="statcount">{{ TotalClasses }}</label>
				<label></label>
			</div>
		</div>

		<div *ngIf="LoadingData == true" style="padding: 5px 10px 5px 10px">
			<div class="alert alert-info">
				<label>Loading...</label>
			</div>
		</div>
	</div>
</div>

<caass-class-attendance-table
	[StartDate]="StartDate"
	[EndDate]="EndDate"
	[SelectedPerson]="SelectedPerson"
	(RefreshStats)="onRefreshStats()"
	(EntrySelected)="onEntrySelected($event)"
>
</caass-class-attendance-table>

<caass-class-attendance-history-table [SelectedEntry]="SelectedEntry" [SelectedPerson]="SelectedPerson"> </caass-class-attendance-history-table>
